import { IOutputField } from '../../types';
import { addCommasToNumber } from '../../../../Utils/CommonUtils';

interface IGSTOutputProps {
  fieldKey: string;
  fieldData: IOutputField;
  formData: Record<string, string | number>;
  calculatedResult: Record<string, string | number>;
}

export const GSTOutputComponent = ({
  fieldKey,
  fieldData,
  formData,
  calculatedResult,
}: IGSTOutputProps): JSX.Element => {
  let dynamicTitle = fieldData.title;
  const gstRate = Number(formData.gstRate || 5);
  if (fieldKey === 'CGST') {
    dynamicTitle = `CGST Amount (${gstRate / 2}%)`;
  } else if (fieldKey === 'SGST') {
    dynamicTitle = `SGST Amount (${gstRate / 2}%)`;
  } else if (fieldKey === 'IGST') {
    dynamicTitle = `IGST Amount (${gstRate}%)`;
  }

  return (
    <div className={fieldData.hide ? 'hidden' : ''}>
      <div className="flex justify-between items-center mb-2">
        <div className="text-s-16 font-semibold">{dynamicTitle}</div>
        <div
          className={`text-s-18 font-bold ${
            fieldData.isValueBlue ? 'text-green-400' : ''
          }`}
        >
          <span>
            {fieldData.prefix && fieldData.prefix.enabled
              ? fieldData.prefix.icon
              : ''}
          </span>{' '}
          <span>{addCommasToNumber(calculatedResult[fieldKey], 2)}</span>
          <span>{fieldData.suffix ? fieldData.suffix : ''}</span>
        </div>
      </div>
      <hr
        className={`my-3 ${
          fieldData.title === '' ||
          calculatedResult[fieldKey] === '' ||
          (fieldData.groupWith && !fieldData.showHrAfter)
            ? 'hidden'
            : ''
        }`}
      />
    </div>
  );
};
